import * as React from "react";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import {
  loadStripe,
  Stripe,
  StripeElements,
  StripeElementsOptions,
  StripeElementsOptionsMode,
} from "@stripe/stripe-js";
import { getPublicEnv } from "./public-env.tsx";

// You can't change stripe elements props without warnings and subtle bugs
// so we manually call elements.update(...) after the initial render
// to keep expected props in sync with the actual elements props
// Also we memoize the stripe loader promise so silence further warnings
export function WrapStripeElements(
  { opts, children }: React.PropsWithChildren<{ opts: StripeElementsOptions }>,
) {
  const [origOpts] = React.useState(opts);
  const [stripePromise] = React.useState(loadStripe(getPublicEnv("STRIPE_PUBLIC_KEY"), {}));
  const elementsRef = React.useRef<StripeElements | null>(null);

  React.useEffect(() => {
    if (elementsRef.current) {
      elementsRef.current.update(opts);
    }
  }, [elementsRef.current, opts]);

  opts.appearance = {
    variables: {
      colorBackground: "#ffffff",
      colorText: "#111111",
      fontFamily: "Roboto, sans-serif",
      borderRadius: "0px",
    },
    rules: {
      ".Input": {
        boxShadow: "0 none",
      },
      ".Input:focus": {
        borderColor: "blue",
        outline: "blue",
        boxShadow: "0 0px 0px 1px blue",
      },
    },
  };

  return (
    <Elements
      stripe={stripePromise}
      options={origOpts}
    >
      <ElementsConsumer>
        {/* see comment above ref declaration */}
        {({ stripe, elements }) => (elementsRef.current = elements) && null}
      </ElementsConsumer>
      {children}
    </Elements>
  );
}
